import { CheckCircle2, ArrowRight } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { Button } from "../../../components/ui/button"
import { Helmet } from "react-helmet-async"
import heroImage from "../../../assets/TopHeroImages/1.jpg"

export default function ManagementProjets() {
    const navigate = useNavigate()
    return (
        <div className="min-h-screen bg-background font-sans text-foreground antialiased">
            <Helmet>
                <title>Master en Management des Projets | FDSEG · Université de Ngozi</title>
                <meta name="description" content="Master en Management des Projets dispensé par la FDSEG. Gestion de projets et pilotage d'organisations." />
            </Helmet>
            <header className="relative min-h-[60vh] flex items-center bg-primary overflow-hidden">
                <div className="absolute inset-0 z-0">
                    {heroImage && <img src={heroImage} alt="Master Management des Projets - FDSEG" className="w-full h-full object-cover opacity-40 mix-blend-luminosity scale-105" />}
                    <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/80 to-transparent" />
                </div>
                <div className="container relative z-10 py-20">
                    <div className="max-w-3xl">
                        <div className="inline-flex items-center gap-4 mb-8">
                            <span className="text-[10px] uppercase tracking-[0.3em] text-accent font-black">Master FDSEG · Gestion</span>
                            <div className="h-px w-12 bg-accent/50" />
                            <span className="text-[10px] text-primary-foreground/60 uppercase tracking-widest font-bold">Formation d'Excellence</span>
                        </div>
                        <h1 className="heading-1 mb-8 leading-[0.95] font-serif tracking-tight text-white">
                            <span className="block italic font-light text-accent/90">Master en</span>
                            <span className="block text-white mt-2">Management des Projets</span>
                        </h1>
                        <div className="border-l-4 border-accent pl-8 mb-12 max-w-2xl">
                            <p className="text-lg md:text-xl font-light leading-relaxed text-primary-foreground/90">
                                Pilotez des projets et des organisations avec des méthodes reconnues, pour le secteur public et privé.
                            </p>
                        </div>
                        <div className="flex flex-wrap gap-6">
                            <Button onClick={() => navigate("/admission")} className="bg-accent text-accent-foreground px-10 py-7 text-sm font-black rounded-xl">
                                Déposer ma Candidature
                                <ArrowRight className="w-5 h-5 ml-3" />
                            </Button>
                            <Button variant="ghost" onClick={() => navigate("/faculte/fdseg#masters")} className="text-white border-2 border-white/20 hover:bg-white/10 px-10 py-7 text-sm font-black rounded-xl">
                                Tous les masters FDSEG
                            </Button>
                        </div>
                    </div>
                </div>
            </header>

            <section className="bg-primary/5 border-b border-border/50">
                <div className="container py-6">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                        {[{ val: "2 Ans", label: "Durée" }, { val: "120", label: "Crédits" }, { val: "Bac+3", label: "Niveau" }, { val: "FDSEG", label: "Faculté" }].map((s, i) => (
                            <div key={i}>
                                <div className="text-2xl font-black text-primary">{s.val}</div>
                                <div className="text-[10px] text-muted-foreground font-black uppercase tracking-widest">{s.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="section-padding bg-background">
                <div className="container max-w-3xl mx-auto text-center">
                    <p className="text-xs font-bold text-primary mb-4 inline-block px-3 py-1 rounded-full bg-primary/10 border border-primary/30">Dispensé par la FDSEG</p>
                    <h2 className="heading-2 text-foreground mb-6">Objectifs du Programme</h2>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed font-medium">
                        Ce master forme des chefs de projet et des managers capables de concevoir, piloter et évaluer des projets dans tous les secteurs, avec une approche rigoureuse et des outils reconnus.
                    </p>
                </div>
            </section>

            <section className="section-padding-sm bg-secondary/20">
                <div className="container max-w-4xl mx-auto">
                    <div className="grid md:grid-cols-2 gap-10">
                        <div>
                            <h3 className="heading-4 text-foreground mb-6 flex items-center gap-3">
                                <div className="w-1 h-6 bg-accent rounded-full" /> Compétences
                            </h3>
                            <ul className="space-y-3">
                                {["Conduite de projet et cycle de vie", "Planification et suivi budgétaire", "Management d'équipe", "Évaluation et reporting"].map((item, i) => (
                                    <li key={i} className="flex items-start gap-3">
                                        <CheckCircle2 className="w-4 h-4 text-accent mt-0.5 flex-shrink-0" />
                                        <span className="text-sm text-muted-foreground font-medium">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h3 className="heading-4 text-foreground mb-6 flex items-center gap-3">
                                <div className="w-1 h-6 bg-accent rounded-full" /> Débouchés
                            </h3>
                            <div className="flex flex-wrap gap-2">
                                {["Chef de projet", "Responsable programme", "Consultant", "ONG", "Secteur public"].map((job, i) => (
                                    <span key={i} className="px-3 py-1.5 bg-background border border-border text-[11px] font-bold uppercase tracking-wider rounded-full">{job}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-padding bg-primary text-white">
                <div className="container text-center max-w-2xl">
                    <h2 className="heading-2 mb-6">Prêt à rejoindre le Master Management des Projets ?</h2>
                    <Button onClick={() => navigate("/admission")} className="bg-accent text-accent-foreground px-8 py-3 text-base font-bold rounded-md">
                        Déposer ma candidature
                        <ArrowRight className="w-5 h-5 ml-2 inline" />
                    </Button>
                </div>
            </section>
        </div>
    )
}
